import React, { useEffect, useState } from 'react';
import { evaluate, sin, cos, tan, sqrt, pi, e, log, number } from 'mathjs';
import './Calculator.scss'
import { NineKOutlined } from '@mui/icons-material';
import { useRef } from 'react';
import ReactQuill from 'react-quill-new';
const expAction = ["*", "/", "-", "+"]
export const Calculator = () => {
  const [expression, setExpression] = useState('');
  const [type, settype] = useState("")
  const [answer, setanswer] = useState("")
  const quillRef = useRef(null)

  const handleButtonClick = (exp, value = "") => {
    if (exp == "Error") { return; }
    if (value == "") {
      value = exp
    }
    // if (value === 'Rad') {
    // } else if (value === 'Deg') {
    // }
    // setExpression((prev) => prev + value);
    // if( value && expression[expression.length-1]!=value) {
    // }
    // setExpression((prev) => prev + value);
    // var isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
    const quill = quillRef.current.getEditor();
       var range = quill.getSelection();
      let position = range ? range.index : 0;
    // var range = quill.getSelection();
    //   console.log((isHTML(value)))
    // if(isHTML(value)){
    //   let txt =  quill.getText()
    //   setExpression((txt + value));
    //   quill.setSelection(position+(txt + value).length);
    // } else {
    //   const quill = quillRef.current.getEditor();
    //   var range = quill.getSelection();
    //   let position = range ? range.index : 0;
    //   quill.insertText(position, value);
    // }

    let txt = expression.replace(/<p>/g, '').replace(/<br[\/]?>/g, '').replace(/<[\/]?p>/g, '')
     txt = txt.substring(0, position) + exp + txt.substring(position);
     setExpression(txt)

    setTimeout(() => {
      quill.setSelection(position + exp.length, 0);
    }, 1);
  };

  const handleClear = () => {
    setExpression('');
  };

  const handleDelete = () => {
    //   const quill = quillRef.current.getEditor();
    // let txt =  quill.getText()

    // let txt=expression.replace(/<sup><[\/]?sup>/g, '')
    //  txt = txt.replace(/<p>/g, '').replace(/<br[\/]?>/g, '').replace(/<[\/]?p>/g, '')

    const editor = quillRef.current.getEditor();
    const selection = editor.getSelection();

    // Ensure there is a valid selection and not at the start of the document
    if (selection && selection.index > 0) {
      const format = editor.getFormat(selection.index - 1); // Check format of last character

      // If the previous character is part of a subscript, remove the formatting before backspacing
      if (format.script === 'sub') {
        editor.formatText(selection.index - 1, 1, { 'script': false }); // Remove subscript
      }
      if (format.script === 'sup') {
        editor.formatText(selection.index - 1, 1, { 'script': false }); // Remove subscript
      }
      editor.deleteText(selection.index - 1, 1);

    }

    // setanswer(txt)
    // setExpression(txt);

  };

  const handleEqual = () => {
    try {
      let txt = expression.replace(/<p>/g, '').replace(/<br[\/]?>/g, '').replace(/<[\/]?p>/g, '')
      txt = txt.replace(/√/g,"sqrt").replace(/π/g, pi.toString()).replace(/<sup>/g,"^").replace(/<[\/]sup>/g,"")
      console.log(txt, "txt")
      setanswer(evaluate(txt).toString());
      
    } catch (e) {
      setanswer('Error');
    }
  };

  function handleChange(value) {
    let txt = value.replace(/<p>/g, '').replace(/<br[\/]?>/g, '').replace(/<[\/]?p>/g, '')
    let prev = expression.replace(/<p>/g, '').replace(/<br[\/]?>/g, '').replace(/<[\/]?p>/g, '')
    txt = txt.replace(prev, "")
    const quill = quillRef.current.getEditor();
    if (Number(txt) >= 0) {
      setExpression(value)
      setTimeout(() => {
        quill.setSelection(quill.getLength() + txt.length, 0);
      }, 1);
    } else if (['*', '+', '-', '.', '^', '%','(',')','!'].includes(txt)) {
      setExpression(prev + txt)
      setTimeout(() => {
        quill.setSelection(quill.getLength() + txt.length, 0);
      }, 1);
    }   else {
        setExpression(prev)
    }

  }
  

  return (
    <div className="calculator"   onKeyDownCapture={(e) => {
      if (e.code === 'Enter') {
        handleEqual()
        e.preventDefault()
      }
    }}>
      <div className="display">
        {/* <input type="text" value={expression} readOnly /> */}
        {/* <input type="text" value={expression}  />
        <EditableMathField
        latex={expression}
        onChange={(mathField) => {
          setExpression(mathField.latex())
        }}
      /> */}
        <ReactQuill
          ref={quillRef}
          theme={"snow"}
          modules={{
            toolbar: null
          }}
          value={expression}
          onChange={(value) => {setExpression(value) }}
        />
        <p>ans: {answer}</p>
      </div>
      <div className="buttons">
        <div className='calc'>
          <div className='c-row'>
            <button onClick={() => handleButtonClick('!')}>x!</button>
            <button onClick={() => handleButtonClick('10<sup>2</sup>', "10^2")}>10²</button>
            <button onClick={() => handleButtonClick('log(')}>log</button>
            <button onClick={() => handleButtonClick('π', pi.toString())}>π</button>
            <button onClick={() => handleButtonClick(answer)}>Ans</button>
          </div>
          <div className='c-row'>
            <button onClick={() => handleButtonClick('(')}>{"("}</button>
            <button onClick={() => handleButtonClick('sin(')}>sin</button>
            <button onClick={() => handleButtonClick('cos(')}>cos</button>
            <button onClick={() => handleButtonClick('tan(')}>tan</button>
            <button onClick={() => settype('Rad')}>Rad</button>
          </div>
          <div className='c-row'>
            <button onClick={() => handleButtonClick(')')}>{")"}</button>
            <button onClick={() => handleButtonClick('^')}>^</button>
            <button onClick={() => handleButtonClick('√(', 'sqrt(')}>√</button>
            <button onClick={() => handleButtonClick('e', e.toString())}>e</button>
            <button onClick={() => settype('Deg')}>Deg</button>
          </div>
          <div className='c-row'>
            <button onClick={handleClear}>C</button>
            <button onClick={() => handleButtonClick('7')}>7</button>
            <button onClick={() => handleButtonClick('4')}>4</button>
            <button onClick={() => handleButtonClick('1')}>1</button>
            <button onClick={() => handleButtonClick('%')}>%</button>
          </div>
          <div className='c-row'>
            <button onClick={handleDelete}>DEL</button>
            <button onClick={() => handleButtonClick('8')}>8</button>
            <button onClick={() => handleButtonClick('5')}>5</button>
            <button onClick={() => handleButtonClick('2')}>2</button>
            <button onClick={() => handleButtonClick('0')}>0</button>
          </div>
          <div className='c-row'>
            <button onClick={() =>{
               
              let txt = expression.replace(/<p>/g, '').replace(/<br[\/]?>/g, '').replace(/<[\/]?p>/g, '')
              txt = txt.slice(txt.length-2,txt.length)
              console.log(txt != "(-" ,txt, "(-",`txt != "(-"`)
              console.log(expression)
              if(txt != "(-"){
                handleButtonClick("(-")
              } 
              else {
                 txt = expression.replace(/<p>/g, '').replace(/<br[\/]?>/g, '').replace(/<[\/]?p>/g, '')
                 console.log(txt,"1")
                txt = txt.slice(0,txt.length-2)
                console.log(txt,"2")
                setExpression((txt + "(+"));
              }
              //  
            }}>+/-</button>
            <button onClick={() => handleButtonClick('9')}>9</button>
            <button onClick={() => handleButtonClick('6')}>6</button>
            <button onClick={() => handleButtonClick('3')}>3</button>
            <button onClick={() => handleButtonClick('.')}>.</button>
          </div>
          <div className='c-row'>
            <button onClick={() => handleButtonClick('/')}>/</button>
            <button onClick={() => handleButtonClick('*')}>*</button>
            <button onClick={() => handleButtonClick('-')}>-</button>
            <button onClick={() => handleButtonClick('+')}>+</button>
            <button onClick={handleEqual}>=</button>
          </div>
        </div>
      </div>
    </div>
  );
};
